import { environment } from '@environments/environment';

interface BaseShowcaseQueryOptions {
  from: number;
  size: number;
}

interface ShowcasesQueryStoreOptions extends BaseShowcaseQueryOptions {
  context: 'store';
  storeUuid?: string;
}

interface ShowcasesQueryWallOptions extends BaseShowcaseQueryOptions {
  context: 'wall';
  layout?: string;
  front?: string;
}

export type ShowcaseQueryOptions = ShowcasesQueryStoreOptions | ShowcasesQueryWallOptions;

export const GET_SHOWCASES_QUERY = (langcode: string, options: ShowcaseQueryOptions) => ({
  query: '_search',
  index:
    (options.context === 'wall'
      ? environment.integrations?.fournierWebservice?.index_mur_realisations
      : environment.integrations?.fournierWebservice?.index_realisations) ?? '',
  body: {
    from: options.from,
    size: options.size,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          ...(options.context === 'wall' && options.layout ? [{ term: { implantation: options.layout } }] : []),
          ...(options.context === 'wall' && options.front ? [{ term: { couleur_et_matiere: options.front } }] : []),
          ...(options.context === 'store' && options.storeUuid ? [{ term: { store_uuid: options.storeUuid } }] : []),
        ],
      },
    },
    sort: [...(options.context === 'store' ? [{ weight: { order: 'asc' } }] : []), { created: { order: 'desc' } }],
    _source: ['title', 'visuels_x5', 'store_name', 'le_mot_du_kitchener'],
  },
});
